var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcManifiestoReenvio = function SvgIcManifiestoReenvio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.83335 11.1666H13.1667V8.66665L17.3334 12.4166L13.1667 16.1666V13.6666H9.83335V11.1666ZM15.6667 0.333313H2.33335C1.89133 0.333313 1.4674 0.508908 1.15484 0.821468C0.842282 1.13403 0.666687 1.55795 0.666687 1.99998V12C0.666687 12.442 0.842282 12.8659 1.15484 13.1785C1.4674 13.491 1.89133 13.6666 2.33335 13.6666H8.16669V12H2.33335V3.66665L9.00002 7.83331L15.6667 3.66665V8.66665H17.3334V1.99998C17.3334 1.55795 17.1578 1.13403 16.8452 0.821468C16.5326 0.508908 16.1087 0.333313 15.6667 0.333313ZM9.00002 6.16665L2.33335 1.99998H15.6667L9.00002 6.16665Z",
    fill: "current"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcManifiestoReenvio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_manifiesto_reenvio.befc7291.svg";
export { ForwardRef as ReactComponent };